import filter from "lodash/filter";

class InstructorCreateReportCardController {
  constructor(
    $state,
    $stateParams,
    DrivesModel,
    FlashService,
    ReportcardsModel,
    tasks,
    student,
    GradeOptionModel,
    $q,
  ) {
    this.loading = true;
    this.drive = {};
    this.grades = [];
    this.gradeIncomplete = true;
    this.gradeOptions = [
      {
        name: "Awesome job!",
        value: "green",
        color: "#64BC5F",
      },
      {
        name: "Good, but not great!",
        value: "yellow",
        color: "#F9C932",
      },
      {
        name: "Needs work, keep practicing!",
        value: "red",
        color: "#FF4646",
      },
      {
        name: "Not Covered",
        value: "grey",
        color: "#cccccc",
      },
    ];
    this.tasks = tasks.map((task) => {
      task.grade = this.gradeOptions[3];
      return task;
    });
    this.reportcard = {
      student: {
        firstname: student.firstname,
        lastname: student.lastname,
      },
    };

    $q.all([
      GradeOptionModel.getGradeOptions(),
      DrivesModel.getDriveByID($stateParams.driveId),
    ]).then((responses) => {
      if (responses[0].grade_options.length > 0) {
        this.gradeOptions = responses[0].grade_options.map((option) => {
          return {
            name: option.option_name,
            value: option.option_value,
            color: option.option_color,
          };
        });
      }
      this.drive = responses[1].drive;
      this.driveDate = new Date(
        this.drive.drive_date + " " + this.drive.start_time,
      );
      const now = new Date();
      const diff = this.driveDate.getTime() - now.getTime();
      const isInPast = diff < 0;
      const absDiff = Math.abs(diff);
      const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (absDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );

      if (days > 0) {
        this.untilDrive = isInPast
          ? `${days} day${days > 1 ? "s" : ""} ago`
          : `in ${days} day${days > 1 ? "s" : ""}`;
      } else if (hours > 0) {
        this.untilDrive = isInPast
          ? `${hours} hour${hours > 1 ? "s" : ""} ago`
          : `in ${hours} hour${hours > 1 ? "s" : ""}`;
      } else {
        this.untilDrive = isInPast ? "a few moments ago" : "in a few moments";
      }
      this.loading = false;
    });

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.DrivesModel = DrivesModel;
    this.FlashService = FlashService;
    this.ReportcardsModel = ReportcardsModel;
  }

  getGrades(tasks) {
    const grades = [];
    tasks.forEach((task) => {
      grades.push({
        task_id: task.id,
        student_id: this.reportcard.student_id,
        name: task.name,
        status: task.grade.value,
      });
    });
    return grades;
  }

  submitGrades(isValid) {
    if (this.busy) {
      return;
    }

    this.submitted = true;

    if (isValid) {
      const grades = this.getGrades(this.tasks);
      const data = {
        drive_id: this.$stateParams.driveId,
        grades: grades,
        internal_note: this.internal_note,
        external_note: this.external_note,
      };

      this.busy = true;
      this.ReportcardsModel.submitGrades(data)
        .then((response) => {
          this.FlashService.setMessage({
            type: "success",
            message: response.message,
          });
          this.submitted = false;
          this.busy = false;
          if (response.redirect === "dashboard") {
            this.$state.go("drivecoach.instructor.dashboard");
          }
          if (response.redirect === "drive") {
            this.$state.go("drivecoach.instructor.dashboard.drive", {
              driveId: this.reportcard.drive_id,
            });
          }
        })
        .catch(() => {
          this.submitted = false;
          this.busy = false;
        });
    } else {
      this.FlashService.setMessage({
        type: "error",
        message: "Please complete the grades.",
      });
    }
  }

  checkGrade() {
    this.gradeIncomplete =
      filter(this.tasks, "grade").length < this.tasks.length;
  }
}
InstructorCreateReportCardController.$inject = [
  "$state",
  "$stateParams",
  "DrivesModel",
  "FlashService",
  "ReportcardsModel",
  "tasks",
  "student",
  "GradeOptionModel",
  "$q",
];

export default InstructorCreateReportCardController;
